import { resolveDynamicComponent as _resolveDynamicComponent, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_navigation_drawer = _resolveComponent("v-navigation-drawer")!

  return (_openBlock(), _createBlock(_component_v_navigation_drawer, {
    modelValue: $setup.isOpen,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.isOpen) = $event)),
    location: $setup.state.options.location,
    width: $setup.state.options.width,
    temporary: !$setup.state.options.persistent,
    scrim: !$setup.state.options.persistent,
    class: "drawer-below-header"
  }, {
    default: _withCtx(() => [
      ($setup.resolvedComponent)
        ? (_openBlock(), _createBlock(_resolveDynamicComponent($setup.resolvedComponent), _mergeProps({
            key: 0,
            ref: "componentRef"
          }, $setup.state.props, {
            drawer: $setup.api,
            onClose: $setup.close
          }), null, 16 /* FULL_PROPS */))
        : _createCommentVNode("v-if", true)
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["modelValue", "location", "width", "temporary", "scrim"]))
}